import BaseModel from '../core/BaseModel'
export default class AppraisalProductApprovalModel extends BaseModel {
    constructor() {
        super({ 
                name: "appraisal_product_approval",
                tableName: 'core_appraisal_product'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
                created_date_text: {
                    name: 'created_date_text',
                    type: "CustomDateTime",
                    label: 'Ngày đổi trả',
                    width: 15,
                    sortable: true,
                    filter: { type: 'DateRange', match: 'custom'},
                    computed: (data) => {
                        data.created_date_text = (data.request_return_product != undefined && data.request_return_product != null) ? data.request_return_product.created_date: ''
                    }
                },
            /*created_date: {
                name: 'created_date', 
                type: "CustomDateTime", 
                label: 'Ngày đổi trả',
                class: 'top-datepicker',
                width: 13
            },*/
            serialNumber: { 
                name: 'serialNumber', 
                label: 'Serial number',
                class: 'center',
                type: "String",
                sortable: false,
                width: 15,
                filter: { type: 'input',  match: 'custom'},
                computed: (data) => {
                   data.serialNumber = (data.serial_number != undefined && data.serial_number != null) ? data.serial_number.serial_number : '';
                }
            },
            modelCode: { 
                name: 'modelCode', 
                label: 'Model sản phẩm',
                class: 'center',
                type: "String",
                sortable: false,
                filter: { type: 'input',  match: 'custom'},
                width: 13,
                computed: (data) => {
                    var productData = (data.serial_number != undefined && data.serial_number != null) ? data.serial_number : null;
                    if(productData != null) {
                        data.modelCode =  (productData.product != undefined && productData.product != null && productData.product.model_code != undefined) ? productData.product.model_code : '';
                    }
                }
            },
            product_name: { 
                name: 'product_name', 
                label: 'Tên sản phẩm',
                class: 'center',
                type: "String",
                sortable: false,
                filter: { type: 'input',  match: 'custom'},
                width: 20,
                computed: (data) => {
                    var productData = (data.serial_number != undefined && data.serial_number != null) ? data.serial_number : null;
                    if(productData != null) {
                        data.product_name =  (productData.product != undefined && productData.product != null && productData.product.name != undefined) ? productData.product.name : '';
                    }
                }
            },
            returnType: {
                name: 'return_type', label: 'Loại dịch vụ', type: "Selection",  dataType: 'Label',  class: 'center', width: 12,
                options: [{ value: 1, label: 'Trả sản phẩm'}, { value: 0, label: 'Đổi sản phẩm'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                sortable: false,
                computed: (data) => {
                    var productData = (data.request_return_product != undefined && data.request_return_product != null) ? data.request_return_product : null;
                    if(productData != null && productData.return_type != undefined && productData.return_type != null) {
                        data.returnType =  productData.return_type;
                    }
                }
            },
            current_status: { 
                name: 'current_status', 
                type: "Selection",
                label: 'Trạng thái thẩm định',
                dataType: 'Label',
                class: 'center',
                width: 12,
                filter: { type: 'select', visible: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                options: [{ value: 0, label: 'Đang yêu cầu'}, { value: 1, label: 'Chờ thẩm định'}, { value: 2, label: 'Hủy yêu cầu'}, { value: 3, label: 'Tự động duyệt'}, { value: 4, label: 'Không duyệt'}, { value: 5, label: 'Đã duyệt'}],
            },
            user_id: {
                refs: 'serial_number_id  appraisal_id request_return_product_id serial_number { serial_number product { model_code name } } request_return_product { return_type request_activation_id created_date}',
                display: false
            }
        },)
    }

}